import { Component, Input, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ButtonExamplesComponent } from '../button/button-examples.component';
import { CardExamplesComponent } from 'src/app/pages/component-examples/card/card-examples.component';
import { CheckboxExamplesComponent } from '../checkbox/checkbox-examples.component';
import { ChipExamplesComponent } from '../chip/chip-examples.component';
import { DialogExamplesComponent } from '../dialog/dialog-examples.component';
import { IconButtonExamplesComponent } from '../icon-button/icon-button-examples.component';
import { FabExamplesComponent } from '../fab/fab-examples.component';
import { TreeExamplesComponent } from '../tree/tree-examples.component';
import { ListExamplesComponent } from '../list/list-examples.component';
import { RadioExamplesComponent } from '../radio/radio-examples.component';
import { TextFieldExamplesComponent } from '../text-field/text-field-examples.component';
import { TabsExamplesComponent } from '../tabs/tabs-examples.component';
import { TableExamplesComponent } from '../table/table-examples.component';
import { MenuExamplesComponent } from '../menu/menu-examples.component';
import { NotificationExamplesComponent } from '../notification/notification-examples.component';
import { ProgressIndicatorsExamplesComponent } from '../progress-indicators/progress-indicators-examples.component';
import { TooltipExamplesComponent } from '../tooltip/tooltip-examples.component';
import { SideSheetExamplesComponent } from 'src/app/pages/component-examples/side-sheet/side-sheet-examples.component';
import { SelectExamplesComponent } from '../select/select-examples.component';
import { SnackbarExamplesComponent } from '../snackbar/snackbar-examples.component';
import { NavrailExamplesComponent } from '../navrail/navrail-examples.component';
import { AppBarExamplesComponent } from '../app-bar/app-bar-examples.component';
import { SwitchExamplesComponent } from '../switch/switch-examples.component';
import { StepperExamplesComponent } from '../stepper/stepper-examples.component';

@Component({
    selector: 'avd-component-examples-page',
    templateUrl: './component-examples-page.component.html',
    styleUrls: ['./component-examples-page.component.scss'],
    imports: [
        ButtonExamplesComponent,
        CardExamplesComponent,
        CheckboxExamplesComponent,
        ChipExamplesComponent,
        DialogExamplesComponent,
        IconButtonExamplesComponent,
        FabExamplesComponent,
        TreeExamplesComponent,
        RadioExamplesComponent,
        TextFieldExamplesComponent,
        TabsExamplesComponent,
        ListExamplesComponent,
        TableExamplesComponent,
        MenuExamplesComponent,
        NotificationExamplesComponent,
        ProgressIndicatorsExamplesComponent,
        TooltipExamplesComponent,
        SideSheetExamplesComponent,
        SelectExamplesComponent,
        SnackbarExamplesComponent,
        NavrailExamplesComponent,
        AppBarExamplesComponent,
        SwitchExamplesComponent,
        StepperExamplesComponent,
    ],
})
export class ComponentExamplesPageComponent implements OnInit {
    @Input() componentName: string = '';
    private readonly route = inject(ActivatedRoute, { optional: true });

    ngOnInit(): void {
        if (this.componentName) {
            return;
        }

        this.componentName =
            this.route?.parent?.snapshot.paramMap.get('componentName') ?? '';
    }
}
